import { useLocation } from 'react-router-dom'
import { usePendingDiagnostic } from './usePendingDiagnostic'
import { useTodayAttendance } from './useTodayAttendance'
import type { EnrollmentStatusCode } from '@/api/attendance'

export type DiagnosticFlowResult = { redirect: string } | null

export interface UseDiagnosticFlowOptions {
  enabled?: boolean
}

/** 진단 강제 진입을 억제하는 파생 상태 (축5C) — WAITING은 진단 응시 주체라 억제하지 않음 */
const SUPPRESSED_STATUSES: EnrollmentStatusCode[] = ['ON_LEAVE', 'WITHDRAWN']

/**
 * 진단테스트 가드. pending이면 /my/diagnostic/:id/:segment 로 redirect.
 * 우선순위: diagnostic → test (App.tsx ProtectedRoute). fail-open.
 */
export function useDiagnosticFlow(options: UseDiagnosticFlowOptions = {}): DiagnosticFlowResult {
  const { enabled = true } = options
  const path = useLocation().pathname
  const { data, isLoading, isError } = usePendingDiagnostic({ enabled })
  const { data: attendance } = useTodayAttendance({ enabled })

  if (!enabled) return null
  if (isLoading || isError) return null
  const pending = data?.pendingDiagnostic
  if (!pending) return null

  // 축5C: 휴원/퇴원 원생은 진단 강제 진입이 소프트 게이트(usePreviewGate)를 우회하므로 억제.
  // attendance 미로드면 기존 가드 유지 (fail-open).
  if (attendance && SUPPRESSED_STATUSES.includes(attendance.enrollmentStatus)) return null

  // 학습자 화면은 수학머리 테스트에만 집중한다. AIQ 완료 뒤의 레벨 채점 및
  // 전체 진단 완료 상태는 관리자 처리용이며 학습자에게 별도 화면을 강제하지 않는다.
  if (pending.status === 'LEVEL_GRADING' || pending.status === 'COMPLETED') return null

  const expected = `/my/diagnostic/${pending.id}/aiq`
  if (path === expected) return null
  return { redirect: expected }
}
